<template>
  <div>
    <!-- Pricing Table Starts -->
    <section class="pricing-table section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>Perfect pricing plan</h2>
              <p>gormless cheeky bugger he nicked it golly gosh a arse show off show off</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>basic</h3>
                <i class="fa fa-home"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">Email Marketing</li>
                <li class="mb-2">Email Builder</li>
                <li class="mb-2">Client Testing</li>
                <li class="mb-2">Multiple Email Support</li>
                <li class="mb-2">Email Read Recepient</li>
                <li>User Free</li>
              </ul>
              <a href="#" class="template-btn">Buy now</a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center mb-4 mb-md-0">
              <div class="table-top">
                <h3>standard</h3>
                <i class="fa fa-home"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">Email Marketing</li>
                <li class="mb-2">Email Builder</li>
                <li class="mb-2">Client Testing</li>
                <li class="mb-2">Multiple Email Support</li>
                <li class="mb-2">Email Read Recepient</li>
                <li>User Free</li>
              </ul>
              <a href="#" class="template-btn">Buy now</a>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-table text-center">
              <div class="table-top">
                <h3>premium</h3>
                <i class="fa fa-building-o"></i>
              </div>
              <ul class="my-5">
                <li class="mb-2">Email Marketing</li>
                <li class="mb-2">Email Builder</li>
                <li class="mb-2">Client Testing</li>
                <li class="mb-2">Multiple Email Support</li>
                <li class="mb-2">Email Read Recepient</li>
                <li>User Free</li>
              </ul>
              <a href="#" class="template-btn">Buy now</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Pricing Table End -->


    <!-- Pricing Box Starts -->
    <div class="pricing-box section-padding3">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="single-box1 text-center mb-4 mb-md-0">
              <h3>submit resume today</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.</p>
              <a href="#" class="template-btn">submit your cv</a>
            </div>
          </div>
          <div class="col-md-6">
            <div class="single-box2 text-center">
              <h3>post a new job now!</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.</p>
              <a href="#" class="template-btn">post a job</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Pricing Box End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// src/pages/PricingPlan.vue